import React from 'react';
import { connect } from 'react-redux';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';

import DaySettingReadOnly from './DaySettingReadOnly/DaySettingReadOnly';
import classes from './SettingReadOnly.css'
import Button from 'react-bootstrap/Button';

class SettingReadOnly extends React.Component{

    callBack = () => {
        if (this.props.callBack) 
            {
                this.props.callBack();
            }
    }

    scheduleHasBeenSet = () => {
        let scheduleHasBeenSet = false;
        let day;
        for (day in this.props.weekSchedule.days) {
            if (this.props.weekSchedule.days[day] != null) {
                scheduleHasBeenSet = true;
                break;
            }
        }
        return scheduleHasBeenSet
    }

    render(){

        let displaySize;
        let buttonVariant;
        let isBlockDisplay;
        let content;

        if (this.props.isMobile===true) {
            displaySize = 'none';
            buttonVariant = 'info';
            isBlockDisplay = true;
        }
        else {
            displaySize = 'none';
            buttonVariant = 'info';
            isBlockDisplay = false;
        }

        if (this.scheduleHasBeenSet() === true) {
            content = 
            <div>
            <Row>
            <Col>
                Current Timezone: <b>{this.props.weekSchedule.timezone ? this.props.weekSchedule.timezone : "Not Set"}</b>
            </Col>
            </Row>
            <div className={classes.DaySettingReadOnlyWindow}>
                <DaySettingReadOnly day='Monday' dayData={this.props.weekSchedule.days.monday}></DaySettingReadOnly>
                <DaySettingReadOnly day='Tuesday' dayData={this.props.weekSchedule.days.tuesday}></DaySettingReadOnly>
                <DaySettingReadOnly day='Wenesday' dayData={this.props.weekSchedule.days.wenesday}></DaySettingReadOnly>
                <DaySettingReadOnly day='Thursday' dayData={this.props.weekSchedule.days.thursday}></DaySettingReadOnly>
                <DaySettingReadOnly day='Friday' dayData={this.props.weekSchedule.days.friday}></DaySettingReadOnly>
                <DaySettingReadOnly day='Saturday' dayData={this.props.weekSchedule.days.saturday}></DaySettingReadOnly>
                <DaySettingReadOnly day='Sunday' dayData={this.props.weekSchedule.days.sunday}></DaySettingReadOnly>
            </div>
            </div>
        }
        else {
            content = 'Please set up your schedule for your friends to book';
        }

        return (
            <Container>
            <Card bsPrefix={classes.CardBody}>
            <Card.Header><b>My Schedule</b></Card.Header>
            <Card.Body>

            { content }

            <Row>
                <Col>
                <div className={classes.ButtonLayout}>
                    <Button block={ isBlockDisplay } size={ displaySize } variant={ buttonVariant } onClick={this.callBack}>Set My Availabilty</Button>
                </div>
                </Col>
            </Row>

            </Card.Body>
            </Card>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        weekSchedule: state.setting.weekSchedule,
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (SettingReadOnly);


// WEBPACK FOOTER //
// ./src/containers/Profile/Setting/ScheduleRead/SettingReadOnly.js